import { useEffect, useState, useCallback } from 'react';

const useSyncCallback = (callback: any) => {
  const [proxyState, setProxyState] = useState({ current: false });
  const [params, setParams] = useState([]);
  const Func = useCallback((...args: any) => {
    setParams(args);
    setProxyState({ current: true });
  }, []);

  useEffect(() => {
    if (proxyState.current === true) setProxyState({ current: false });
  }, [proxyState]);

  useEffect(() => {
    proxyState.current && callback(...params);
  });

  return Func;
};

export default useSyncCallback;
/*
 * @lastTime: 2021-02-26 15:29:11
 * @param: callback为回调函数
 * @Description: 用法 const newFunc = useSyncCallback(yourCallback)
 */
